import React from 'react';
import PropTypes from 'prop-types';
import {useDragLayer} from 'react-dnd';
import {DragDropType, ExplorerContentTypes} from '../../constants/dataEnum';
import StackedItemsDragPreview from './StackedItemsDragPreview';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }
  const {x, y} = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

function DragPreviewLayer(props) {
  const {selectedItemCount} = props;
  const {itemType, isDragging, item, initialOffset, currentOffset} = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  function renderItem() {
    switch (itemType) {
      case DragDropType.PROTOCOL_EXPLORER_ITEM:
        return (
          <StackedItemsDragPreview
            itemCount={selectedItemCount ?? 0}
            iconName={item.protocol.type === ExplorerContentTypes.FOLDER ? 'Folder' : 'Protocol'}
          />
        );
      default:
        return null;
    }
  }

  if (!isDragging) {
    return null;
  }

  const containerClassNames = ['drag-layer'];
  if (item?.id) containerClassNames.push(String(item.id));

  return (
    <div className={containerClassNames.join(' ')} style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>{renderItem()}</div>
    </div>
  );
}

DragPreviewLayer.propTypes = {
  selectedItemCount: PropTypes.number,
};

DragPreviewLayer.defaultProps = {
  selectedItemCount: 0,
};

export default React.memo(DragPreviewLayer);
